import { Box, Text } from '@genial/components';
import { BoxRadius } from '@genial/design-tokens';
import { Utils } from '@genial/utils';

export interface HasRelatedTermProps {
  hasRelatedTerm?: boolean;
}

export const HasRelatedTermFlag = ({ hasRelatedTerm }: HasRelatedTermProps) => {
  if (!hasRelatedTerm) {
    return null;
  }

  return (
    <Box
      w="18px"
      h="18px"
      borderRadius={BoxRadius.circular}
      bg="backgroundshade"
      alignItems="center"
      justifyContent="center">
      <Text
        color={Utils.ColorToken.WithOpacity('brand.primary.principal', 'opacity.intense')}
        fontSize="xs">
        +1
      </Text>
    </Box>
  );
};
